export default __webpack_public_path__ + "static/media/sopEditIcon.3206704f.svg";